/**
 * Advertising platform identifiers.
 */
export enum AdPlatform {
  META = 'META',
  GOOGLE = 'GOOGLE',
  TWITTER = 'TWITTER',
  TIKTOK = 'TIKTOK',
}

/**
 * Campaign lifecycle status.
 */
export enum CampaignStatus {
  DRAFT = 'DRAFT',
  PENDING_REVIEW = 'PENDING_REVIEW',
  APPROVED = 'APPROVED',
  REJECTED = 'REJECTED',
  ACTIVE = 'ACTIVE',
  PAUSED = 'PAUSED',
  COMPLETED = 'COMPLETED',
  FAILED = 'FAILED',
  ARCHIVED = 'ARCHIVED',
}

/**
 * Campaign advertising objective.
 */
export enum CampaignObjective {
  AWARENESS = 'AWARENESS',
  TRAFFIC = 'TRAFFIC',
  CONVERSIONS = 'CONVERSIONS',
  TICKET_SALES = 'TICKET_SALES',
}

/**
 * Creative asset type.
 */
export enum CreativeType {
  IMAGE = 'IMAGE',
  VIDEO = 'VIDEO',
  CAROUSEL = 'CAROUSEL',
  TEXT = 'TEXT',
}

/**
 * Notification type.
 */
export enum NotificationType {
  CAMPAIGN_APPROVED = 'CAMPAIGN_APPROVED',
  CAMPAIGN_REJECTED = 'CAMPAIGN_REJECTED',
  CAMPAIGN_COMPLETED = 'CAMPAIGN_COMPLETED',
  /** Backend's generic campaign lifecycle event (launched, completed, paused, …) */
  CAMPAIGN_STATUS = 'CAMPAIGN_STATUS',
  BUDGET_ALERT = 'BUDGET_ALERT',
  PERFORMANCE_ALERT = 'PERFORMANCE_ALERT',
  PLATFORM_ERROR = 'PLATFORM_ERROR',
  ACCOUNT_CONNECTED = 'ACCOUNT_CONNECTED',
  ACCOUNT_DISCONNECTED = 'ACCOUNT_DISCONNECTED',
  ACCOUNT_UPDATE = 'ACCOUNT_UPDATE',
  BILLING_ALERT = 'BILLING_ALERT',
  SYSTEM = 'SYSTEM',
}

/**
 * User role within Promote.
 */
export enum UserRole {
  ORGANIZER = 'ORGANIZER',
  ADMIN = 'ADMIN',
  SUPER_ADMIN = 'SUPER_ADMIN',
}
